import { useEffect } from "react";

/**
 * Mounts at /app/laboratorio (and /laboratorio).
 * The Laboratorio is a self-contained single-file SPA at /laboratorio.html
 * (vanilla JS + CSS, intentionally outside React for portability).
 * This component simply hands control to that file, preserving a clean React URL.
 */
export default function LaboratorioRedirect() {
  useEffect(() => {
    window.location.replace("/laboratorio.html");
  }, []);
  return (
    <div
      data-testid="lab-redirect"
      style={{
        minHeight: "100vh",
        background: "#0e0c0a",
        color: "#f5f1e8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'JetBrains Mono', ui-monospace, monospace",
        fontSize: "11px",
        letterSpacing: ".22em",
        textTransform: "uppercase",
      }}
    >
      M · LABORATORIO · CARGANDO...
    </div>
  );
}
